module.exports = __webpack_public_path__ + "img/178.38e5560d.jpg";